import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'reactstrap';
import {countBy} from 'lodash';
import {toastr} from 'react-redux-toastr';
import AddressesView from '../Addresses/AddressesView';
import CommunicationsView from '../Communications/CommunicationsView';
import AttachmentsView from '../Attachments/AttachmentsView';
import NotesView from '../Notes/NotesView';
import TextBoxControl from '../Common/TextBoxControl';
import {SHORT_DATE_FORMAT} from "../../constants";
import moment from "moment";

class ContactView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      contact: props.contact ? props.contact : {
        id: -1, firstName: '', lastName: '',
        addresses: [],
        communications: [],
        attachments: [],
        notes: [],
      },
      isEdit: props.isEdit,
      selectedNote: null,
    };

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleInvite = this.handleInvite.bind(this);
    this.handleCancelInvite = this.handleCancelInvite.bind(this);
    
    this.getCurrentState = this.getCurrentState.bind(this);
  }

  handleFieldChange(e){
    let x = {...this.state.contact};

    if(e.target.type=="checkbox"){
      x[`${e.target.name}`] = e.target.checked;
    }
    else if(e.target.type=='number') {
      x[`${e.target.name}`] = e.target.value.replace(/\D/g,'');
    }
    else {
      x[`${e.target.name}`] = e.target.value;
    }

    this.setState({contact: x});
  }  

  handleSave(){
    let current = this.getCurrentState();
    if(current){
      this.props.onSave(current);
    } else {
      toastr.error('Please complete the contact form');
    }
  }

  handleInvite(){
    let current = this.getCurrentState();
    if(current){
      this.props.onInvite(current);
    } else {
      toastr.error('Please complete the contact form');
    }
  }

  handleCancelInvite(){
    let current = this.getCurrentState();
    if(current && this.props.onCancelInvite){
      this.props.onCancelInvite(current);
    } else {
      toastr.error('Please complete the contact form');
    }
  }

  handleCancel(){
    this.props.onCancel();
  }

  getCurrentState(){
    if(this.state.contact.firstName.trim()=='' || this.state.contact.lastName.trim()==''){
      return null;
    }
    let addresses = this.refs.addresses.getCurrentState();
    let communications = this.refs.communications.getCurrentState();

    if(addresses == null || communications == null){
      return null;
    }
    return {...this.state.contact, addresses, communications};
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(prevProps.contact) !== JSON.stringify(this.props.contact)){
      this.setState({contact: this.props.contact});
    }
  }

  render(){

    return this.state.isEdit ?
      (
        <div className="form-horizontal col-12">
          <TextBoxControl
            name={'position'}
            labelText={'Position'}
            value={this.state.contact.position}
            onChange={this.handleFieldChange}
          />

          <TextBoxControl
            name={'firstName'}
            labelText={'First Name'}
            value={this.state.contact.firstName}
            onChange={this.handleFieldChange}
          />

          <TextBoxControl
            name={'lastName'}
            labelText={'Last Name'}
            value={this.state.contact.lastName}
            onChange={this.handleFieldChange}
          />

          <AddressesView
            addresses={this.state.contact.addresses}
            ref="addresses"
            onChange={(addresses)=> this.setState({contact: {...this.state.contact, addresses}})}
            enableDelete
            enableAdd
            enableAddressType
            enableIsPrimary
          />

          <div className="form-group row">&nbsp;</div>

          <CommunicationsView
            communications={this.state.contact.communications}
            ref="communications"
            onChange={(communications)=> this.setState({contact: {...this.state.contact, communications}})}
            manageUser={this.props.manageUser}
            selectedRoles={this.props.selectedRoles}
            userId={this.props.userId}
          />

          <div className="form-group row">&nbsp;</div>

          <AttachmentsView
            headerText={'Attachments'}
            attachments={this.state.contact.attachments}
            onChange={(attachments)=> this.setState({contact: {...this.state.contact, attachments}})}
           />

          <div className="form-group row">&nbsp;</div>

          <NotesView
            notes={this.state.contact.notes}
            onChange={(notes)=> this.setState({contact: {...this.state.contact, notes}})}
          />

          <div className="form-group row">&nbsp;</div>
          {this.props.onSave &&
          <div className="form-group row">
              {this.props.onInvite && !this.state.contact.invitedByUserName &&
                <Button color="default" style={{marginRight:'10px'}} onClick={this.handleInvite}><i className="fa fa-plus" />&nbsp;&nbsp;Invite User</Button>
              }
              <Button color="success" onClick={this.handleSave}><i className="fa fa-save" />&nbsp;&nbsp;Save</Button>&nbsp;
              <Button color="danger" onClick={this.handleCancel}><i className="fa fa-times" />&nbsp;&nbsp;Cancel</Button>
          </div> }

          {this.state.contact.invitedByUserName && this.props.onCancelInvite &&
          (this.state.contact.inviteAcceptedDate ? <div className="form-group row">
              Contact invited by&nbsp;<b>{this.state.contact.invitedByUserName}</b>&nbsp;on&nbsp;<b>{moment(this.state.contact.invitedDate).format(SHORT_DATE_FORMAT)}</b>
              &nbsp;accepted&nbsp;<b>{moment(this.state.contact.inviteAcceptedDate).format(SHORT_DATE_FORMAT)}</b>
            </div> :
            <div className="form-group row">
              Contact invited by&nbsp;<b>{this.state.contact.invitedByUserName}</b>&nbsp;on&nbsp;<b>{moment(this.state.contact.invitedDate).format(SHORT_DATE_FORMAT)}</b>
              &nbsp;<Button color={'danger'} onClick={this.handleCancelInvite}>Cancel Invite</Button>
            </div>)
          }

        </div>

      )
      :
      (<div>View mode really</div>);
  }
}

ContactView.propTypes = {
  contact: PropTypes.object.isRequired,
  onContactUpdated: PropTypes.func,
  isEdit: PropTypes.bool,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onInvite: PropTypes.func,
  onCancelInvite: PropTypes.func,
};

ContactView.defatultProps = {
  isEdit: true,
};

export default ContactView;